import { NavigationButton } from "@components/atoms/NavigationButton";
import { WasteCatagoryType } from "@utils/isValidWasteCategoryAndRoute";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { RoutesList } from "../../../../routes/Routes";
import { useWasteStore } from "../../../../store/store";
import { RadioOptions } from "@components/molecules/RadioOptions";

const radioOptions = {
  true: "Using the Report it assistant",
  false: "Using the new form",
};

export const ASSISTANT_URL = import.meta.env.MAINSITE_ASSISTANT_URL;

export const BeforeYouStart = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const {
    updateWasteCategory,
    wasteCategory,
    resetAllUploadPhoto,
    resetWasteDetails,
  } = useWasteStore();
  const [option, setOption] = useState("");

  useEffect(() => {
    if (
      wasteCategory === "" ||
      (wasteCategory !== ("" as WasteCatagoryType) &&
        searchParams.get("type") !== null)
    ) {
      const userSearchWastetype = searchParams.get("type") as WasteCatagoryType;
      updateWasteCategory(userSearchWastetype);
      resetAllUploadPhoto();
      resetWasteDetails();
    }
  }, []);

  return (
    <main>
      <div className="flex flex-col gap-x-2">
        <section>
          <RadioOptions
            id={"Start your report options"}
            labelTextOptionOne={radioOptions.true}
            subtextOptionOne="The assistant helps identify the issue to report"
            labelTextOptionTwo={radioOptions.false}
            subtextOptionTwo="Answer some questions to report the issue"
            name="Start your report options"
            onChange={(option) => {
              setOption(option);
            }}
          />

          <div className="my-10 flex items-center justify-between font-bold">
            <NavigationButton
              icon={true}
              text="Start your report"
              type="primary"
              className={`m-auto inline-flex rounded-md bg-button-default md:m-0 md:w-auto lg:w-auto xl:w-auto`}
              disabled={option.length === 0}
              navigateToDestination={() => {
                if (option === radioOptions.true) {
                  if (wasteCategory) {
                    window.location.href = `${ASSISTANT_URL}?category=${wasteCategory}`;
                  } else {
                    window.location.href = ASSISTANT_URL;
                  }
                } else {
                  navigate(RoutesList.UPLOAD_PHOTO);
                }
              }}
            />
          </div>
        </section>

        <section>
          <div className="header-4 mt-2 font-semibold">
            How to make your report
          </div>
          <p className="body-1 mt-5">
            You can upload a photo if you have one. Reports with photos help us
            to understand the type of problem we need to investigate.
          </p>
        </section>

        <section className="body-1 mt-5">
          We’ll need to know:
          <ul className="m-5 list-outside list-disc">
            <li>the location of the issue</li>
            <li>what the issue is or looks like </li>
          </ul>
        </section>
      </div>
    </main>
  );
};
